<template>
  <div class="installationSelectList">
    <Grid
      :ref="kgm_ref"
      :style="{ height: 'auto' }"
      :data-items="kgm_computedGridItems(installationsCopy)"
      :columns="kgm_responsiveColumns()"
      :filterable="true"
      :filter="kgm_filter"
      :pageable="kgm_pagable"
      :page-size="kgm_take"
      :skip="kgm_skip"
      :take="kgm_take"
      :total="kgm_allGridItems(installationsCopy)"
      :sortable="{
        allowUnsort: kgm_allowUnsort,
        mode: kgm_sortMode,
      }"
      :sort="kgm_sort"
      selected-field="selected"
      @rowclick="kgm_gridOnRowClick, onSelectionChange"
      @filterchange="kgm_gridFilterChange"
      @pagechange="kgm_gridPageChange"
      @sortchange="kgm_gridSortChange"
      @selectionchange="onSelectionChange"
      @headerselectionchange="onHeaderSelectionChange"
    >
      <div
        slot="textFilter"
        slot-scope="{ props, methods }"
        class="input-group"
      >
        <input
          ref="textFilterInput"
          :value="props.value"
          type="text"
          class="form-control mr-2 rounded-right"
          placeholder="please enter an value"
          @input="
            (event) => {
              methods.change({
                operator: 'contains',
                field: props.field,
                value: event.target.value,
                syntheticEvent: event,
              });
            }
          "
        />
        <div
          v-if="props.value"
          class="input-group-append"
        >
          <button
            class="btn btn-light border rounded"
            @click="
              kgm_resetInput('textFilterInput', (event) => {
                methods.change({
                  operator: '',
                  field: '',
                  value: '',
                  syntheticEvent: event,
                });
              })
            "
          >
            <font-awesome-icon
              class="gray"
              icon="times"
            />
          </button>
        </div>
      </div>
    </Grid>
  </div>
</template>

<script>
import { kendoGridMixin } from "@/mixins/kendoGridMixin.js";

export default {
  name: "InstallationSelectList",
  mixins: [kendoGridMixin],
  props: {
    installations: {
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
    selected: {
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      selectedField: "selected",
      selectedInstallations: [],
      installationsCopy: [],
      kgm_columns: [
        {
          field: "selected",
          width: "50px",
          filterable: false,
        },
        {
          field: "id",
          filterable: true,
          filter: "text",
          title: "Name",
          width: "200px",
          filterCell: "textFilter",
        },
        {
          field: "installationType",
          filterable: true,
          filter: "text",
          title: "Type",
          width: "200px",
          filterCell: "textFilter",
        },
        {
          field: "name",
          filterable: true,
          filter: "text",
          title: "Name",
          filterCell: "textFilter",
        },
      ],
    };
  },
  created() {
    if (this.installations && this.installations.length) {
      this.installationsCopy = [...this.installations];
      this.installationsCopy = this.installationsCopy.map((x) => ({
        ...x,
        selected: this.selected.some(ev => ev.id === x.id)
      }));
    }
  },
  methods: {
    onSelectionChange(event) {
      this.$set(
        event.dataItem,
        this.selectedField,
        !event.dataItem[this.selectedField]
      );
      this.selectedInstallations = this.installationsCopy.filter((x) => {
        return x.selected;
      });
      this.$emit("setSelectedList", this.selectedInstallations);
    },
    onHeaderSelectionChange(event) {
      let checked = event.event.target.checked;
      const visible = this.kgm_computedAllGridItems(
        this.installationsCopy
      )
      this.installationsCopy = this.installationsCopy.map((x) => ({
        ...x,
        selected: visible.some(v => v.id === x.id) ? checked : x.selected,
      }));
      this.selectedInstallations = this.installationsCopy.filter((x) => {
        return x.selected;
      });
      this.$emit("setSelectedList", this.selectedInstallations);
    },
  },
};
</script>
<style>
.installationSelectList .k-grid table tr:hover td {
  background: rgb(219, 219, 219) !important;
  cursor: pointer !important;
}
</style>
